import React, { useEffect, useRef, useState } from 'react';
import './NossoEspaco.css';
import Img1 from '../../assets/espaco/img-1.webp';
import Img2 from '../../assets/espaco/img-2.webp';
import Img3 from '../../assets/espaco/img-3.webp';
import Img4 from '../../assets/espaco/img-4.webp';
import Img5 from '../../assets/espaco/img-5.webp';
import Img6 from '../../assets/espaco/img-6.webp';
import Img7 from '../../assets/espaco/img-7.webp';
import Img8 from '../../assets/espaco/img-8.webp';
import Img9 from '../../assets/espaco/img-9.webp';
import Img10 from '../../assets/espaco/img-10.webp';
import Img12 from '../../assets/espaco/img-12.webp';
import Img13 from '../../assets/espaco/img-13.webp';
import Img14 from '../../assets/espaco/img-14.webp';
import Img15 from '../../assets/espaco/img-15.webp';
import '../../../src/styles/mediaqueries.css';

const NossoEspaco = () => {
  const imageListRef = useRef(null);
  const slideButtonsRef = useRef([]);
  const [currentX, setCurrentX] = useState(0);
  const [maxTranslateX, setMaxTranslateX] = useState(0);
  const scrollAmountRef = useRef(0);

  // touch support
  const isDragging = useRef(false);
  const startTouchX = useRef(0);
  const currentTranslate = useRef(0);

  useEffect(() => {

    const updateSizes = () => {
      const imageList = imageListRef.current;
      const containerWidth = imageList.parentElement.clientWidth;
      const items = imageList.querySelectorAll('.image-item');
    
      if (items.length === 0) return;
    
      const itemWidth = items[0].offsetWidth;
      const itemStyle = getComputedStyle(imageList);
      const gap = parseFloat(itemStyle.gap) || 0;
      const scrollAmount = itemWidth + gap;
    
      scrollAmountRef.current = scrollAmount;
    
      let extraSpace = 0;
      const width = window.innerWidth;

      if (width <= 480) {
        extraSpace = itemWidth * 2.5;
      } else if (width <= 768) {
        extraSpace = itemWidth * 0.3;
      }

      const totalWidth = imageList.scrollWidth + extraSpace;
    
      const newMaxTranslateX = Math.max(totalWidth - containerWidth, 0);
      setMaxTranslateX(newMaxTranslateX);
    
      const clampedX = Math.min(currentX, newMaxTranslateX);
      setCurrentX(clampedX);
      imageList.style.transform = `translateX(-${clampedX}px)`;
    
      updateSlideButtons(clampedX);
    };    

    const updateSlideButtons = (position = currentX) => {
      const prevButton = slideButtonsRef.current[0];
      const nextButton = slideButtonsRef.current[1];

      if (prevButton) prevButton.style.display = position <= 0 ? 'none' : 'block';
      if (nextButton) nextButton.style.display = position >= maxTranslateX - 5 ? 'none' : 'block';
    };

    const onResize = () => {
      updateSizes();
    };

    updateSizes();
    window.addEventListener('resize', onResize);
    setTimeout(updateSizes, 100); 

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [currentX, maxTranslateX]);

  useEffect(() => {
    const images = imageListRef.current.querySelectorAll('img');
    let loadedCount = 0;
  
    const checkAllLoaded = () => {
      loadedCount++;
      if (loadedCount === images.length) {
        const event = new Event('resize');
        window.dispatchEvent(event);
      }
    };
  
    images.forEach((img) => {
      if (img.complete) {
        checkAllLoaded();
      } else {
        img.addEventListener('load', checkAllLoaded);
        img.addEventListener('error', checkAllLoaded);
      }
    });
  
    return () => {
      images.forEach((img) => {
        img.removeEventListener('load', checkAllLoaded);
        img.removeEventListener('error', checkAllLoaded);
      });
    };
  }, []);

  const handleSlideClick = (direction) => {
    const scrollAmount = scrollAmountRef.current;
    const newX = Math.max(0, Math.min(currentX + direction * scrollAmount, maxTranslateX));
    animateTranslateX(currentX, newX, 300);
  };

  const animateTranslateX = (start, end, duration) => {
    const imageList = imageListRef.current;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = progress < 0.5
        ? 2 * progress * progress
        : -1 + (4 - 2 * progress) * progress;

      const current = start + (end - start) * ease;
      imageList.style.transform = `translateX(-${current}px)`;

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCurrentX(end);
      }
    };

    requestAnimationFrame(animate);
  };

  const handleTouchStart = (e) => {
    isDragging.current = true;
    startTouchX.current = e.touches[0].clientX;
    currentTranslate.current = currentX;
  };

  const handleTouchMove = (e) => {
    if (!isDragging.current) return;
    const delta = startTouchX.current - e.touches[0].clientX;
    const nextX = Math.max(0, Math.min(currentTranslate.current + delta, maxTranslateX));
    imageListRef.current.style.transform = `translateX(-${nextX}px)`;
  };

  const handleTouchEnd = () => {
    if (!isDragging.current) return;
    isDragging.current = false;
  
    const transform = window.getComputedStyle(imageListRef.current).transform;
  
    let translateX = 0;
    if (transform && transform !== 'none') {
      const values = transform.match(/matrix.*\((.+)\)/);
      if (values) {
        translateX = parseFloat(values[1].split(', ')[4]);
      }
    }
  
    const clampedX = Math.min(-translateX, maxTranslateX);
    setCurrentX(clampedX);
  };  

  return (
    <div>
      <div className="container">
        <div className="text-center">
          <h2 className="section-title">Nosso Espaço</h2>
          <p className="section-subtitle">
            Estamos localizados no Jardim Vergueiro, em Sorocaba. O edifício conta com recepção,
            estacionamento pago e uma deliciosa lanchonete na parte de fora.
          </p>
        </div>

        <div className="slider-wrapper">
            <button
              id="prev-slide"
              className="slide-button material-symbols-rounded"
              onClick={() => handleSlideClick(-1)}
              ref={(el) => (slideButtonsRef.current[0] = el)}
            >
              chevron_left
            </button>
          <div className="slider-viewport">
            <div
              className="image-list"
              ref={imageListRef}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              {[Img1, Img2, Img8, Img9, Img3, Img6, Img4, Img5, Img7, Img10, Img12, Img13, Img14, Img15].map((img, index) => (
                <img key={index} src={img} alt={`img-${index + 1}`} loading="eager" className="image-item" />
              ))}
            </div>
          </div>
            <button
              id="next-slide"
              className="slide-button material-symbols-rounded"
              onClick={() => handleSlideClick(1)}
              ref={(el) => (slideButtonsRef.current[1] = el)}
            >
              chevron_right
            </button>
        </div>

        <p className="section-subtitle">
          O espaço é aconchegante. Nossas salas são climatizadas e preparadas para os atendimentos!
        </p>
      </div>
    </div>
  );
};

export default NossoEspaco;
